import React from "react";
const DownArrowSVG = ({ color = "black", className, onClick }) => {
  return (
    <svg
      width="12"
      height="18"
      viewBox="0 0 12 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        id="Vector"
        d="M2.20658 12.5416C1.86724 12.2218 1.31709 12.2218 0.977759 12.5416C0.638436 12.8614 0.638436 13.3798 0.977759 13.6997L5.03173 17.5203C5.71034 18.1599 6.81072 18.1599 7.48933 17.5203L11.5457 13.6973C11.885 13.3775 11.885 12.859 11.5457 12.5392C11.2064 12.2195 10.6562 12.2195 10.3169 12.5392L7.13152 15.5414V0.818895C7.13152 0.366627 6.74251 0 6.26262 0C5.78272 0 5.39372 0.366627 5.39372 0.818895V15.5452L2.20658 12.5416Z"
        fill={color}
      />
    </svg>
  );
};

export default DownArrowSVG;
